import React from "react";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { alertActions, customerTab } from "../../locales/en";
import CommonModal from "./CommonModal";

const UnavailableModal = ({ isOpen, toggle, modalData, status }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={() => toggle(false)}
      modalClassName={"modal-dialog-centered"}
      footerButtons={[
        {
          label: alertActions.ok,
          className: "btn btn-primary",
          onClick: () => toggle(false)
        }
      ]}
    >
      {status === true ? (
        <div className={Modalstyle.unvContent}>
          <span className="text-center d-block">
            <IoMdInformationCircleOutline />
          </span>
          <h2 className="text-center"> {modalData?.directDebit?.title}</h2>
          <p>{modalData?.directDebit?.description}</p>
          <p>{modalData?.mandate?.description}</p>
        </div>
      ) : (
        <div className={Modalstyle.unvContent}>
          <span className="text-center d-block">
            <IoMdInformationCircleOutline />
          </span>
          <h2 className="text-center">
            {customerTab.directDebit.unavalbleModal.title}
          </h2>
          <p>{customerTab.directDebit.unavalbleModal.weAre}</p>
        </div>
      )}
    </CommonModal>
  );
};
UnavailableModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  modalData: PropTypes.string,
  status: PropTypes.bool
};

export default UnavailableModal;
